import App from 'app/app.js';

function LtCyopCtrl($scope, $window, $rootScope) {
  this.onClickSelect = function (index) {
    $scope.onSelect({ index: index });
  };

  this.selectLook = function (orderLineDetail, index) {
    $scope.onSelectLook({ orderLineDetail: orderLineDetail, index: index });
  };

  this.onCustomizeItem = function (orderLineDetail, index) {
    $scope.customizeItem({ orderLineDetail: orderLineDetail, index: index });
  };

  this.isEdit = function (item) {
    return !!item.orderLineItemSelections;
  };

  this.onRemoveItem = function (index) {
    $scope.removeItem({ index: index });
  };

  $rootScope.$on('on-cyop-choose-item', function (event, index) {
    $scope.onSelect({ index: index });
  });
}

App.controller('LtCyopCtrl', ['$scope', '$window', '$rootScope', LtCyopCtrl]);
